import { render } from "./OrderTacker.vue?vue&type=template&id=1e33fb83"
import script from "./OrderTacker.vue?vue&type=script&lang=js"
export * from "./OrderTacker.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Website/Website/front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__